<header class="header">
  <div class="logo">
    <img src="assets/Logo.jpg" alt="Toyota Logo">
      <div class="divider"></div>
     <span class="system-title">COMPLIANCE EVIDENCE REPOSITORY & TRACKING</span>
  </div>
 
  <div class="nav-menu">
    <ul>
      <li>
        <a class="nav-link" aria-label="help" (click)="openHelpAndSupport()" class="pill-btn flex-shrink-0"  title="Help & Support" >
          <mat-icon class="font-icon">help_outline</mat-icon>
        </a>
      </li>
      
      <li>
        <a class="nav-link" aria-label="Go to department" (click)="onClick()" class="pill-btn flex-shrink-0"  title="Notifications" >
          <mat-icon class="font-icon">notifications_none</mat-icon>
        </a>
      </li>

      <li class="profile-menu">
        <div class="profile-trigger" (click)="toggleProfileDropdown()">
          <ng-container *ngIf="hasProfilePhoto(); else triggerFallbackAvatar">
            <img [src]="userProfile.profilePic" [alt]="userProfile.name" class="trigger-avatar-img">
          </ng-container>
          <ng-template #triggerFallbackAvatar>
            <div class="avatar-fallback trigger-avatar-fallback" [attr.aria-label]="userProfile.name">
              <mat-icon>person</mat-icon>
            </div>
          </ng-template>
          <span class="avatar-name">{{ userProfile.name }}</span>
        </div>
        
        <div *ngIf="profileDropdownOpen" class="profile-dropdown" (mouseleave)="closeProfileDropdown()">
          <div class="profile-header">
            <ng-container *ngIf="hasProfilePhoto(); else dropdownFallbackAvatar">
              <img [src]="userProfile.profilePic" [alt]="userProfile.name" class="profile-avatar-img">
            </ng-container>
            <ng-template #dropdownFallbackAvatar>
              <div class="avatar-fallback profile-avatar-fallback" [attr.aria-label]="userProfile.name">
                <mat-icon>person</mat-icon>
              </div>
            </ng-template>
            <div class="profile-info">
              <p class="profile-name">{{ userProfile.name }}</p>
              <p class="profile-title">{{ userProfile.jobTitle }}</p>
            </div>
          </div>
          <div class="profile-divider"></div>
          
          <!-- Role Toggle -->
          <div class="profile-role-toggle" *ngIf="canToggleRole">
            <div class="toggle-label">View as:</div>
            <div class="toggle-buttons">
              <button 
                class="toggle-btn" 
                [class.active]="currentViewRole === availableRoles[0]"
                (click)="switchRole(availableRoles[0])"
              >
                {{ getRoleDisplayName(availableRoles[0]) }}
              </button>
              <button 
                class="toggle-btn" 
                [class.active]="currentViewRole === availableRoles[1]"
                (click)="switchRole(availableRoles[1])"
              >
                {{ getRoleDisplayName(availableRoles[1]) }}
              </button>
            </div>
          </div>
          
          <div class="profile-divider"></div>
          
          <ul class="profile-options">
            <li (click)="onLogout()">
              <mat-icon>logout</mat-icon>
              <span>Logout</span>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</header>
